import React from 'react';
import { Helmet } from 'react-helmet-async';

const PrivacyPolicyPage = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | Trusted Trademark Filer</title>
        <meta name="description" content="Read our Privacy Policy to understand how Trusted Trademark Filer collects, uses, and protects your personal information during trademark registration services." />
      </Helmet>
      <div className="min-h-screen bg-white">
        <section className="py-20">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-5xl font-bold text-gray-900 mb-8">
              Privacy Policy
            </h1>
            <div className="text-gray-600 space-y-6 leading-relaxed">
              <div className="space-y-4">
                <h2 className="text-2xl font-bold text-gray-900 mt-8">
                  1. Information We Collect
                </h2>
                <p>
                  We collect information that you provide directly to us, including name, email address, contact number, and any other information you choose to provide when using our trademark registration services.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8">
                  2. How We Use Your Information
                </h2>
                <p>
                  We use the information we collect to:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Provide, maintain, and improve our services</li>
                  <li>Process your trademark registration applications</li>
                  <li>Communicate with you about services, updates, and promotional offers</li>
                  <li>Monitor and analyze trends and usage</li>
                  <li>Detect, prevent, and address technical issues</li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8">
                  3. Information Sharing and Disclosure
                </h2>
                <p>
                  We do not sell, trade, or rent your personal information to third parties. We may share your information with:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Government agencies (USPTO) as required for trademark filing</li>
                  <li>Service providers who assist in our operations</li>
                  <li>Legal authorities when required by law</li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8">
                  4. Data Security
                </h2>
                <p>
                  We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8">
                  5. Your Rights
                </h2>
                <p>
                  You have the right to:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Access your personal information</li>
                  <li>Correct inaccurate data</li>
                  <li>Request deletion of your data</li>
                  <li>Opt-out of marketing communications</li>
                  <li>Lodge a complaint with a supervisory authority</li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8">
                  6. Cookies and Tracking
                </h2>
                <p>
                  We use cookies and similar tracking technologies to track activity on our website and hold certain information to improve your experience.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8">
                  7. Changes to This Policy
                </h2>
                <p>
                  We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8">
                  8. Contact Us
                </h2>
                <p>
                  If you have any questions about this Privacy Policy, please contact us at:
                </p>
                <p className="font-semibold">
                  Email: Info@trustedtrademarkfiler.com<br />
                  Phone: +1 (888) 203 1471<br />
                  Address: 28202 Cabot Rd #300, Laguna Niguel, CA 92677, United States
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default PrivacyPolicyPage;